// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legible {
  font-family: monospace;
  font-size: 1.5rem;
  letter-spacing: 5px;
}

ol {
  margin-bottom: 0;
  padding-left: 0;
}

ol li {
  padding-bottom: 5px;
}

ol.start {
  counter-reset: mycounter;
}

ol.start li, ol.continue li {
  list-style: none;
}

ol.start li:before, ol.continue li:before {
  content: counter(mycounter) ". ";
  counter-increment: mycounter;
}

/* QR Modal */
::ng-deep .qrcode img {
  cursor: pointer;
}

#qrImageModal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
}
#qrImageModal ::ng-deep .qrcode {
  height: 100%;
  padding: 30px;
}
#qrImageModal ::ng-deep .qrcode img {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
}

.qrimgcode ::ng-deep div img {
  width: 150px;
  height: auto;
}
@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
.close {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 45px;
  transition: 0.3s;
  color: #b4bdce;
}

.close:hover,
.close:focus {
  cursor: pointer;
  color: #7987a1;
}

#overlay {
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
}

.loading {
  opacity: 0.05;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/enrollment/methods/soft-token/soft-token.component.scss"],"names":[],"mappings":"AAUA;EACE,sBAAA;EACA,iBAAA;EACA,mBAAA;AATF;;AAYA;EACE,gBAAA;EACA,eAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,wBAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,gCAAA;EACA,4BAAA;AATF;;AAYA,aAAA;AAEA;EACE,eAAA;AAVF;;AAaA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAVF;AAYE;EACE,YAAA;EACA,aAAA;AAVJ;AAYI;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAVN;;AAkBM;EACE,YAAA;EACA,YAAA;AAfR;AA+BA;EACE;IACE,mBAAA;EApBF;EAuBA;IACE,mBAAA;EArBF;AACF;AAwBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAnGS;AA6EX;;AAyBA;;EAEE,eAAA;EACA,cAvGS;AAiFX;;AAyBA;EACE,eAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAtBF;;AAyBA;EACE,aAAA;AAtBF","sourcesContent":["$gray-100: #f4f5f8;\n$gray-200: #e3e7ed;\n$gray-300: #cdd4e0;\n$gray-400: #b4bdce;\n$gray-500: #97a3b9;\n$gray-600: #7987a1;\n$gray-700: #596882;\n$gray-800: #3b4863;\n$gray-900: #1c273c;\n\n.legible {\n  font-family: monospace;\n  font-size: 1.5rem;\n  letter-spacing: 5px;\n}\n\nol {\n  margin-bottom: 0;\n  padding-left: 0;\n}\n\nol li {\n  padding-bottom: 5px;\n}\n\nol.start {\n  counter-reset: mycounter;\n}\n\nol.start li, ol.continue li {\n  list-style: none;\n}\n\nol.start li:before, ol.continue li:before {\n  content: counter(mycounter) \". \";\n  counter-increment: mycounter;\n}\n\n/* QR Modal */\n\n::ng-deep .qrcode img {\n  cursor: pointer;\n}\n\n#qrImageModal {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2001;\n\n  ::ng-deep .qrcode {\n    height: 100%;\n    padding: 30px;\n\n    img {\n      display: block;\n      margin: auto;\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n}\n\n.qrimgcode {\n  ::ng-deep {\n    div {\n      img {\n        width: 150px;\n        height: auto;\n      }\n    }\n  }\n}\n\n@-webkit-keyframes zoom {\n  from {\n    -webkit-transform: scale(0)\n  }\n\n  to {\n    -webkit-transform: scale(1)\n  }\n}\n\n@keyframes zoom {\n  from {\n    transform: scale(0)\n  }\n\n  to {\n    transform: scale(1)\n  }\n}\n\n.close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-size: 45px;\n  transition: 0.3s;\n  color: $gray-400;\n}\n\n.close:hover,\n.close:focus {\n  cursor: pointer;\n  color: $gray-600;\n}\n\n#overlay {\n  position: fixed;\n  background: rgb(0,0,0,.7);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2000;\n}\n\n.loading {\n  opacity: 0.05;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
